module.exports = __webpack_public_path__ + "img/sycret.f9faa732.png";